import { Field } from 'formik'
import React from 'react'

import { ColorInput, Fieldset, Input } from '@fourthwall/components'

import type { FormValues } from '../../../../utils/FormValues'

type ColorFormProps = {
  setFieldValue: (field: string, value: string) => void
  values: FormValues
}

export const ColorForm = ({ setFieldValue, values }: ColorFormProps) => {
  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field name="label" component={Input} label="Label" placeholder="Setting label" />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name="info"
            component={Input}
            label="Info (optional)"
            placeholder="Help text for this setting"
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <ColorInput
            label="Default Value (optional)"
            value={typeof values.default === 'string' ? values.default : ''}
            onChange={(value) => setFieldValue('default', value)}
          />
        </Fieldset.Item>
      </Fieldset.Row>
    </>
  )
}
